import React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";

const Mui = (props) => {
  const { children } = props;
  const { darkTheme } = useSelector((state) => state.styles);
  const { restaurantConfig } = useSelector((state) => state.config);
  // Override the default size of material ui
  const theme = createTheme({
    palette: {
      mode: darkTheme ? "light" : "dark",

      primary: {
        main: restaurantConfig ? restaurantConfig.theme.primary : "#28a745",
      },
      secondary: {
        main: restaurantConfig ? restaurantConfig.theme.secondary : "#f66187",
      },
      tertiary: {
        main: restaurantConfig ? restaurantConfig.theme.tertiary : "#1f2544",
      },
    },
    typography: {
      htmlFontSize: 12,
      fontFamily: "inherit",
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          html: {
            fontSize: "62.5%",
          },
        },
      },
    },
  });
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Mui;
